(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["returns"]) return;
  try {
    
  function initializeReturns(root) {
    root.querySelectorAll('.returns-nav').forEach((navigation) => {
      const page = navigation.closest('.returns-page');
      const tabs = Array.from(navigation.querySelectorAll('[data-return-tab]'));
      const panels = tabs.map((tab) => page.querySelector(`[id="${tab.hash.slice(1)}"]`));
      if (!tabs.length || panels.some((panel) => !panel)) return;

      function select(index) {
        tabs.forEach((tab, i) => {
          tab.setAttribute('aria-selected', String(i === index));
          tab.tabIndex = i === index ? 0 : -1;
          panels[i].hidden = i !== index;
        });
      }

      function activate(index) {
        select(index);
        history.replaceState(history.state, '', tabs[index].hash);
      }

      navigation.setAttribute('role', 'tablist');
      tabs.forEach((tab, index) => {
        tab.id ||= `${panels[index].id}-tab`;
        tab.setAttribute('role', 'tab');
        tab.setAttribute('aria-controls', panels[index].id);
        panels[index].setAttribute('role', 'tabpanel');
        panels[index].setAttribute('aria-labelledby', tab.id);
        tab.addEventListener('click', (event) => {
          event.preventDefault();
          activate(index);
        });
        tab.addEventListener('keydown', (event) => {
          let next;
          switch (event.key) {
            case 'ArrowLeft': next = (index + tabs.length - 1) % tabs.length; break;
            case 'ArrowRight': next = (index + 1) % tabs.length; break;
            case 'Home': next = 0; break;
            case 'End': next = tabs.length - 1; break;
            default: return;
          }
          event.preventDefault();
          activate(next);
          tabs[next].focus();
        });
      });

      page.addEventListener('shopify:block:select', (event) => {
        const index = panels.findIndex((panel) => panel.contains(event.target));
        if (index !== -1) select(index);
      });
      const index = tabs.findIndex((tab) => tab.hash === location.hash);
      select(index === -1 ? 0 : index);
    });
  }

  initializeReturns(document);
  document.addEventListener('shopify:section:load', (event) => initializeReturns(event.target));
  window.addEventListener('hashchange', () => {
    const tab = Array.from(document.querySelectorAll('.returns-nav [data-return-tab]')).find((tab) => tab.hash === location.hash);
    tab?.click();
  });

  } catch(e) { console.error(e); }
})();
})();
